"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.PermissionConditionType = exports.WarningConditionType = exports.ErrorConditionType = exports.ConditionType = void 0;
var condition_1 = require("./condition");
var observable_array_1 = require("./observable-array");
var allConditionTypes = {};
var ConditionType = /** @class */ (function () {
    /**
    * Creates a unique type of model condition.
    * @param code The unique condition type code.
    * @param category The category of the condition type, such as "Error", "Warning", or "Permission".
    * @param message The default message to use when the condition is present.
    * @param sets One or more sets the condition type belongs to.
    */
    function ConditionType(code, category, message, sets) {
        // Ensure unique condition type codes
        if (allConditionTypes[code])
            throw new Error("A condition type with the code \"" + code + "\" has already been created.");
        this.code = code;
        this.category = category;
        this.message = message;
        // this.rules = [];
        this.conditions = observable_array_1.ObservableArray.create();
        this.sets = observable_array_1.ObservableArray.ensureObservable(sets || []);
        // Register with the static dictionary of all condition types
        allConditionTypes[code] = this;
    }
    /**
    * Adds or removes a condition from the model for the specified target if necessary.
    * @param condition Whether or not the condition should be present
    * @param target The target instance
    * @param properties The properties to attach the condition to
    * @param message The condition message (or a function to generate the message)
    */
    ConditionType.prototype.when = function (source, condition, target, message) {
        // get the current condition if it exists
        var conditionTarget = target.meta.getCondition(this);
        // add the condition on the target if it does not exist yet
        if (condition) {
            // if the message is a function, invoke to get the actual message
            message = message instanceof Function ? message(target) : message;
            // create a new condition if one does not exist
            if (!conditionTarget) {
                return new condition_1.Condition(this, message, target, source, source.properties);
            }
            // replace the condition if the message has changed
            else if (message && message !== conditionTarget.condition.message) {
                // destroy the existing condition
                conditionTarget.condition.destroy();
                // create a new condition with the updated message
                return new condition_1.Condition(this, message, target, source, source.properties);
            }
            // otherwise, just return the existing condition
            else {
                return conditionTarget.condition;
            }
        }
        // Destroy the condition if it exists on the target and is no longer valid
        if (conditionTarget != null)
            conditionTarget.condition.destroy();
        // Return null to indicate that no condition was created
        return null;
    };
    /**
        * Gets all condition types that have been created.
        * @returns Array of all condition types.
        * */
    ConditionType.all = function () {
        var all = [];
        for (var type in allConditionTypes.keys) {
            all.push(allConditionTypes[type]);
        }
        return all;
    };
    /**
        * Returns the condition type with the given code, if it exists.
        * @param code The unique code of the condition type to find.
        */
    ConditionType.get = function (code) {
        return allConditionTypes[code];
    };
    ;
    return ConditionType;
}());
exports.ConditionType = ConditionType;
var ErrorConditionType = /** @class */ (function (_super) {
    __extends(ErrorConditionType, _super);
    function ErrorConditionType(code, message, sets) {
        return _super.call(this, code, "Error", message, sets) || this;
    }
    return ErrorConditionType;
}(ConditionType));
exports.ErrorConditionType = ErrorConditionType;
var WarningConditionType = /** @class */ (function (_super) {
    __extends(WarningConditionType, _super);
    function WarningConditionType(code, message, sets) {
        return _super.call(this, code, "Warning", message, sets) || this;
    }
    return WarningConditionType;
}(ConditionType));
exports.WarningConditionType = WarningConditionType;
var PermissionConditionType = /** @class */ (function (_super) {
    __extends(PermissionConditionType, _super);
    function PermissionConditionType(code, message, sets, isAllowed) {
        if (isAllowed === void 0) { isAllowed = true; }
        var _this = _super.call(this, code, "Warning", message, sets) || this;
        _this.isAllowed = !(isAllowed === false);
        return _this;
    }
    return PermissionConditionType;
}(ConditionType));
exports.PermissionConditionType = PermissionConditionType;
